import { defineStore } from 'pinia'
import { Speaker } from '../../../../lib/models/speaker'
import { StoreHelper } from '../../helpers/storeHelper'

export const useSpeakerStore = defineStore('speaker', {
  state: () => ({
    speakers: [] as any[],
    total: 0,
  }),
  actions: {
    async findAllSpeakers({ query, url }: { query?: any, url?: string } = {}) {
      if (!url) {
        url = StoreHelper.loadRootState('endpointSpeaker').url
      }
      const { findAll } = StoreHelper.loadRootState()
      let arr = await findAll({ url }, query)
      if (Array.isArray(arr.data)) {
        arr = arr.data
      }
      if (Array.isArray(arr) && arr.length > 0) {
        const speakers = Speaker.initOnlyValidFromArray(arr || [])
        this.speakers = speakers
        this.total = speakers.length || 0
        return {
          speakers,
          total: speakers.length || 0
        }
      }
      throw StoreHelper.error(arr, 'No speaker found.')
    }
  }
})
